export const kpi = (() => {
    const mainElement = document.getElementById("main");
    if (!mainElement) return;
    const contentLink = mainElement.getAttribute("data-contentlink");

    document.addEventListener("DOMContentLoaded", function () {
        var toggleGroupingElement = document.querySelector("[data-toggle-grouping]");

        if (toggleGroupingElement) {
            toggleGrouping();
        }

        var dropdowns = document.querySelectorAll(".js-choose-active-company");

        // Loopa igenom varje dropdown och lägg till eventlyssnare
        dropdowns.forEach(function (dropdown) {
            dropdown.addEventListener("change", function () {
                // Hämta det valda alternativets värde
                var selectedOption = dropdown.options[dropdown.selectedIndex].value;
                var newURL = window.location.origin + window.location.pathname + selectedOption;

                // Utför omdirigering
                window.location.href = newURL;
            });
        });

        document.addEventListener("click", function (event) {
            const target = event.target;

            // Kolla om klicket skedde på en edit, cancel eller save-knapp
            if (target.dataset.editForm) {
                handleKpiData(event, "edit");
            } else if (target.dataset.cancel) {
                handleKpiData(event, "cancel");
            } else if (target.dataset.kpiDone) {
                doneKpi(event);
            }
            else if (target.dataset.kpiDelete) {
                deleteKpi(event);
            }
            else if (target.dataset.section && target.type === "submit") {
                saveKpiData(event);
            }
        });
    });

    function handleKpiData(event, action) {
        event.preventDefault();
        const form = event.target.closest(".container");
        const formData = new FormData();

        let data;
        if (action === "edit") {
            data = {
                id: event.target.getAttribute("data-edit-form"),
                section: event.target.getAttribute("data-section"),
            };
        } else if (action === "cancel") {
            data = {
                id: event.target.getAttribute("data-cancel"),
                section: event.target.getAttribute("data-section"),
                disabled: true,
            };
        }

        data.contentLink = contentLink;

        Object.entries(data).forEach(([key, value]) => {
            formData.append(key, value);
        });

        fetch("./EditKpiData/", {
            method: "POST",
            body: formData,
            cache: "no-cache",
        })
            .then((response) => response.text())
            .then((responseText) => {
                form.innerHTML = responseText;
                toggleGrouping();
            })
            .catch((error) => {
                console.error("Error:", error);
            });
    }

    function saveKpiData(event) {
        event.preventDefault();
        const form = event.target.closest(".container");
        const formData = new FormData(event.target.closest("form"));
        const id = formData.get("Form.KpiId");

        let data;
        data = {
            contentLink: contentLink,
            section: event.target.getAttribute("data-section"),
        };

        Object.entries(data).forEach(([key, value]) => {
            formData.append(key, value);
        });

        fetch("./SaveKpiData/", {
            method: "POST",
            body: formData,
            cache: "no-cache",
        })
            .then((response) => response.text())
            .then((responseText) => {
                form.innerHTML = responseText;
                updateKpiData(id, "done");
                toggleGrouping();
            })
            .catch((error) => {
                console.error("Error:", error);
            });
    }
    function doneKpi(event) {
        event.preventDefault();
        const formData = new FormData(event.target.closest("form"));

        fetch("./IsDoneKpiData/", {
            method: "POST",
            body: formData,
            cache: "no-cache",
        })
            .then((response) => response.json())
            .then((data) => {
                if (data.success) {
                    location.reload();
                }
            })
            .catch((error) => {
                console.error("Error:", error);
            });
    }

    function deleteKpi(event) {
        event.preventDefault();

        if (window.confirm("Är du säker du vill radera denna rad?")) {
            const formData = new FormData(event.target.closest("form"));

            fetch("./deleteKpiData/", {
                method: "POST",
                body: formData,
                cache: "no-cache"
            })
                .then(response => response.json())
                .then(data => {
                    if (data.success) {
                        location.reload();
                    }
                })
                .catch(error => {
                    console.error("Error:", error);
                });

        }
    }

    function toggleGrouping() {
        var group = document.querySelector(".js-group-toggle").value;
        var distributionElements = document.querySelectorAll("[data-group-distribution]");
        var manufacturingElements = document.querySelectorAll("[data-group-manufacturing]");

        if (group === "") {
            distributionElements.forEach(function (element) {
                element.style.display = "none";
            });
            manufacturingElements.forEach(function (element) {
                element.style.display = "none";
            });
        } else if (group === "Nej") {
            distributionElements.forEach(function (element) {
                element.style.display = "none";
            });
            manufacturingElements.forEach(function (element) {
                element.style.display = "";
            });
        } else {
            distributionElements.forEach(function (element) {
                element.style.display = "";
            });
            manufacturingElements.forEach(function (element) {
                element.style.display = "none";
            });
        }
    }

    function updateKpiData(id, section) {
        const formData = new FormData();
        formData.append("contentLink", contentLink);
        formData.append("id", id);
        formData.append("section", section);

        fetch("./UpdateKpiData/", {
            method: "POST",
            body: formData,
            cache: "no-cache",
        })
            .then((response) => response.text())
            .then((data) => {
                document.getElementById(section).innerHTML = data;
                toggleGrouping();
            })
            .catch((error) => {
                console.error("Error:", error);
            });
    }
})();
